(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dynamic-review-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const MAX_CARD = 360;

    function init(root) {
      if (!root || root.dataset.rcReady) return;
      const viewport = root.querySelector('[data-rc-viewport]');
      const track = root.querySelector('[data-rc-track]');
      if (!viewport || !track) return;
      root.dataset.rcReady = 'true';

      const prevBtn = root.querySelector('[data-rc-prev]');
      const nextBtn = root.querySelector('[data-rc-next]');
      const originals = Array.from(track.querySelectorAll('[data-rc-card]'));
      const count = originals.length;

      let perView = 3;
      let cardW = MAX_CARD;
      let gap = 20;
      let copies = 0; // clone sets on each side
      let index = 0; // track index of the first fully visible card
      let enabled = false;
      let timer = null;

      function layout() {
        const width = root.clientWidth;
        gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        perView = width >= 1100 ? 3 : width >= 700 ? 2 : 1;
        const peek = perView === 1 ? 34 : 60;
        cardW = Math.min(MAX_CARD, (width - 2 * peek - (perView - 1) * gap) / perView);
        root.style.setProperty('--rc-card-w', cardW + 'px');
        root.style.setProperty('--rc-window', perView * cardW + (perView - 1) * gap + 'px');

        const wasEnabled = enabled;
        enabled = count > perView;
        prevBtn.hidden = nextBtn.hidden = !enabled;

        if (enabled && !copies) buildClones(width);
        if (!enabled && copies) removeClones();
        if (enabled !== wasEnabled) index = copies * count;
        position(false);
      }

      function buildClones(width) {
        // enough clones to fill the wider side area on huge screens
        const sideCards = Math.ceil(width / 2 / (cardW + gap)) + perView + 1;
        copies = Math.max(1, Math.ceil(Math.max(sideCards, 8) / count));
        const makeSet = () => originals.map((card) => {
          const clone = card.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
          clone.removeAttribute('data-shopify-editor-block');
          clone.dataset.rcClone = 'true';
          return clone;
        });
        for (let i = 0; i < copies; i++) {
          track.prepend(...makeSet());
          track.append(...makeSet());
        }
      }

      function removeClones() {
        track.querySelectorAll('[data-rc-clone]').forEach((c) => c.remove());
        copies = 0;
      }

      function offsetFor(i) {
        const windowW = perView * cardW + (perView - 1) * gap;
        const start = enabled ? (root.clientWidth - windowW) / 2 : (root.clientWidth - (count * cardW + (count - 1) * gap)) / 2;
        return start - i * (cardW + gap);
      }

      function position(animate, extra = 0) {
        track.classList.toggle('is-animating', animate);
        track.style.transform = `translate3d(${offsetFor(enabled ? index : 0) + extra}px, 0, 0)`;
        const cards = track.children;
        for (let i = 0; i < cards.length; i++) {
          const visible = !enabled || (i >= index && i < index + perView);
          cards[i].classList.toggle('is-visible', visible);
        }
        root.classList.add('is-ready');
      }

      function normalize() {
        const first = copies * count;
        if (index >= first + count || index < first) {
          index = first + (((index - first) % count) + count) % count;
          position(false);
        }
      }

      function go(step) {
        if (!enabled) return;
        normalize();
        index += step;
        position(true);
      }

      track.addEventListener('transitionend', (e) => {
        if (e.target === track) normalize();
      });
      prevBtn.addEventListener('click', () => { go(-1); restart(); });
      nextBtn.addEventListener('click', () => { go(1); restart(); });

      // swipe / drag
      let startX = null;
      let startY = 0;
      let dx = 0;
      let dragging = false;
      let suppressClick = false;
      viewport.addEventListener('pointerdown', (e) => {
        if (!enabled || (e.pointerType === 'mouse' && e.button !== 0)) return;
        normalize();
        startX = e.clientX;
        startY = e.clientY;
        dx = 0;
        dragging = false;
        suppressClick = false;
      });
      viewport.addEventListener('pointermove', (e) => {
        if (startX === null) return;
        dx = e.clientX - startX;
        if (!dragging) {
          if (Math.abs(dx) < 6 || Math.abs(dx) < Math.abs(e.clientY - startY)) return;
          dragging = true;
          viewport.setPointerCapture(e.pointerId);
          viewport.classList.add('is-dragging');
          stop();
        }
        position(false, dx);
      });
      const end = () => {
        if (startX === null) return;
        startX = null;
        viewport.classList.remove('is-dragging');
        if (!dragging) return;
        dragging = false;
        suppressClick = true;
        const steps = Math.min(perView, Math.round(Math.abs(dx) / (cardW + gap)) || (Math.abs(dx) > 40 ? 1 : 0));
        index -= Math.sign(dx) * steps;
        position(true);
        restart();
      };
      viewport.addEventListener('pointerup', end);
      viewport.addEventListener('pointercancel', end);
      // a drag must not open the card link underneath
      viewport.addEventListener('click', (e) => {
        if (suppressClick) e.preventDefault();
        suppressClick = false;
      }, true);

      // autoplay
      const autoplay = root.dataset.autoplay === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches;
      const speed = (parseFloat(root.dataset.autoplaySpeed) || 5) * 1000;
      function stop() { clearInterval(timer); timer = null; }
      function restart() {
        stop();
        if (autoplay && enabled) timer = setInterval(() => go(1), speed);
      }
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', restart);
      root.addEventListener('focusin', stop);

      let resizeFrame;
      window.addEventListener('resize', () => {
        cancelAnimationFrame(resizeFrame);
        resizeFrame = requestAnimationFrame(layout);
      });

      layout();
      restart();

      // theme editor: jump to the selected review
      root.addEventListener('shopify:block:select', (e) => {
        const i = originals.indexOf(e.target);
        if (i < 0 || !enabled) return;
        stop();
        index = copies * count + i - Math.floor((perView - 1) / 2);
        position(true);
      });
    }

    const initAll = (scope = document) => scope.querySelectorAll('[data-review-carousel]').forEach(init);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    !window.Theme.settings.enable_cart_redirection && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', (event) => {
    // Update cart count in header (adapted from Product.js updateCart function)
    window.Shopify.getCart(cart => {
      const cartAmountWrap = document.querySelector('[data-header-cart-count]');
      if (cartAmountWrap) {
        cartAmountWrap.innerHTML = `(${cart.item_count})`;
      }
    });
  });

  document.addEventListener('product-form:cart:update', (event) => {
    // Update cart count when cart state changes (using cart data from event)
    const cartAmountWrap = document.querySelector('[data-header-cart-count]');
    if (cartAmountWrap && event.detail.cart) {
      cartAmountWrap.innerHTML = `(${event.detail.cart.item_count})`;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
